import _objectSpread from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { isPowerOfTwo as t } from "../../core/mathUtils.js";
import { isSome as e } from "../../core/maybe.js";
import { checkWebGLError as i } from "./checkWebGLError.js";
import { ResourceType as a } from "./enums.js";
import r from "./capabilities/isWebGL2Context.js";
var s = 4;

var o = /*#__PURE__*/function () {
  function o(t, e) {
    var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    _classCallCheck(this, o);

    this._context = t, this.type = "texture", this._glName = null, this._descriptor = void 0, this._samplingModeDirty = !1, this._wrapModeDirty = !1, t.instanceCounter.increment(a.Texture, this), this._descriptor = _objectSpread({
      target: 3553,
      samplingMode: 9729,
      wrapMode: 10497,
      flipped: !1,
      hasMipmap: !1,
      isOpaque: !1,
      unpackAlignment: 4,
      preMultiplyAlpha: !1
    }, e), 34067 === this._descriptor.target ? this.setDataCubeMap(i) : this.setData(i);
  }

  _createClass(o, [{
    key: "glName",
    get: function get() {
      return this._glName;
    }
  }, {
    key: "descriptor",
    get: function get() {
      return this._descriptor;
    }
  }, {
    key: "isDirty",
    get: function get() {
      return this._samplingModeDirty || this._wrapModeDirty;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this._context.gl && this._glName && (this._context.unbindTextureAllUnits(this), this._context.gl.deleteTexture(this._glName), this._glName = null, this._context.instanceCounter.decrement(a.Texture, this));
    }
  }, {
    key: "release",
    value: function release() {
      this.dispose();
    }
  }, {
    key: "resize",
    value: function resize(t, e) {
      var i = this._descriptor;
      i.width === t && i.height === e || (i.width = t, i.height = e, 34067 === this._descriptor.target ? this.setDataCubeMap(null) : this.setData(null));
    }
  }, {
    key: "setDataCubeMap",
    value: function setDataCubeMap() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      for (var _e = 34069; _e <= 34074; _e++) {
        this.setData(t, _e);
      }
    }
  }, {
    key: "setData",
    value: function setData(t) {
      var a = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3553;
      if (!this._context || !this._context.gl) return;
      var r = this._context.gl;
      this._glName || (this._glName = r.createTexture()), void 0 === t && (t = null), null === t && (this._descriptor.width = this._descriptor.width || s, this._descriptor.height = this._descriptor.height || s);

      var p = this._context.bindTexture(this, o.TEXTURE_UNIT_FOR_UPDATES),
          h = this._descriptor;

      o._validateTexture(this._context, h), r.pixelStorei(r.UNPACK_ALIGNMENT, h.unpackAlignment), r.pixelStorei(r.UNPACK_FLIP_Y_WEBGL, h.flipped ? 1 : 0), r.pixelStorei(r.UNPACK_PREMULTIPLY_ALPHA_WEBGL, h.preMultiplyAlpha ? 1 : 0);
      var l = h.pixelFormat;
      var d = h.internalFormat ? h.internalFormat : this._deriveInternalFormat(l, h.dataType);

      if (t instanceof ImageData || t instanceof HTMLImageElement || t instanceof HTMLCanvasElement || t instanceof HTMLVideoElement) {
        var _e2 = t.width,
            _s = t.height;
        t instanceof HTMLVideoElement && (_e2 = t.videoWidth, _s = t.videoHeight), h.width && h.height, r.texImage2D(a, 0, d, l, h.dataType, t), i(r), h.hasMipmap && this.generateMipmap(), void 0 === h.width && (h.width = _e2), void 0 === h.height && (h.height = _s);
      } else {
        null != h.width && null != h.height || console.error("Width and height must be specified!"), r.DEPTH24_STENCIL8 && d === r.DEPTH_STENCIL && (d = r.DEPTH24_STENCIL8);
        var _s2 = h.width,
            _o2 = h.height;

        if (n(t)) {
          var _e3 = Math.round(Math.log(Math.max(_s2, _o2)) / Math.LN2) + 1;

          h.hasMipmap = h.hasMipmap && _e3 === t.levels.length;

          for (var _i = 0;; ++_i) {
            var _e4 = t.levels[Math.min(_i, t.levels.length - 1)];
            if (r.compressedTexImage2D(a, _i, d, _s2, _o2, 0, _e4), 1 === _s2 && 1 === _o2 || !h.hasMipmap) break;
            _s2 = Math.max(1, _s2 >> 1), _o2 = Math.max(1, _o2 >> 1);
          }
        } else if (e(t)) r.texImage2D(a, 0, d, _s2, _o2, 0, l, h.dataType, t), i(r), h.hasMipmap && this.generateMipmap();else for (var _t = 0; r.texImage2D(a, _t, d, _s2, _o2, 0, l, h.dataType, null), i(r), (1 !== _s2 || 1 !== _o2) && h.hasMipmap; ++_t) {
          _s2 = Math.max(1, _s2 >> 1), _o2 = Math.max(1, _o2 >> 1);
        }
      }

      o._applySamplingMode(r, this._descriptor), o._applyWrapMode(r, this._descriptor), o._applyAnisotropicFilteringParameters(this._context, this._descriptor), i(r), this._context.bindTexture(p, o.TEXTURE_UNIT_FOR_UPDATES);
    }
  }, {
    key: "updateData",
    value: function updateData(t, e, i, a, r, s) {
      var n = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 3553;
      s || console.error("An attempt to use uninitialized data!"), this._glName || console.error("An attempt to update uninitialized texture!");

      var p = this._context.gl,
          h = this._descriptor,
          l = this._context.bindTexture(this, o.TEXTURE_UNIT_FOR_UPDATES);

      (e < 0 || i < 0 || a > h.width || r > h.height || e + a > h.width || i + r > h.height) && console.error("An attempt to update out of bounds of the texture!"), p.pixelStorei(p.UNPACK_ALIGNMENT, h.unpackAlignment), p.pixelStorei(p.UNPACK_FLIP_Y_WEBGL, h.flipped ? 1 : 0), p.pixelStorei(p.UNPACK_PREMULTIPLY_ALPHA_WEBGL, h.preMultiplyAlpha ? 1 : 0), s instanceof ImageData || s instanceof HTMLImageElement || s instanceof HTMLCanvasElement || s instanceof HTMLVideoElement ? p.texSubImage2D(n, t, e, i, h.pixelFormat, h.dataType, s) : p.texSubImage2D(n, t, e, i, a, r, h.pixelFormat, h.dataType, s), this._context.bindTexture(l, o.TEXTURE_UNIT_FOR_UPDATES);
    }
  }, {
    key: "generateMipmap",
    value: function generateMipmap() {
      var t = this._descriptor;
      t.hasMipmap || (t.hasMipmap = !0, this._samplingModeDirty = !0, o._validateTexture(this._context, t)), 9729 === t.samplingMode ? (this._samplingModeDirty = !0, t.samplingMode = 9985) : 9728 === t.samplingMode && (this._samplingModeDirty = !0, t.samplingMode = 9984);

      var e = this._context.bindTexture(this, o.TEXTURE_UNIT_FOR_UPDATES);

      this._context.gl.generateMipmap(t.target), this._context.bindTexture(e, o.TEXTURE_UNIT_FOR_UPDATES);
    }
  }, {
    key: "setSamplingMode",
    value: function setSamplingMode(t) {
      t !== this._descriptor.samplingMode && (this._descriptor.samplingMode = t, this._samplingModeDirty = !0);
    }
  }, {
    key: "setWrapMode",
    value: function setWrapMode(t) {
      t !== this._descriptor.wrapMode && (this._descriptor.wrapMode = t, o._validateTexture(this._context, this._descriptor), this._wrapModeDirty = !0);
    }
  }, {
    key: "applyChanges",
    value: function applyChanges() {
      var t = this._context.gl,
          e = this._descriptor;
      this._samplingModeDirty && (o._applySamplingMode(t, e), this._samplingModeDirty = !1), this._wrapModeDirty && (o._applyWrapMode(t, e), this._wrapModeDirty = !1);
    }
  }, {
    key: "_deriveInternalFormat",
    value: function _deriveInternalFormat(t, e) {
      if ("webgl" === this._context.webglVersion) return t;
      if (5126 === e) switch (t) {
        case 6408:
          return 34836;

        case 6407:
          return 34837;

        default:
          throw new Error("Unable to derive format");
      }
      return t;
    }
  }], [{
    key: "_validateTexture",
    value: function _validateTexture(e, i) {
      (i.width < 0 || i.height < 0) && console.error("Negative dimension parameters are not allowed!");
      var a = t(i.width) && t(i.height);
      r(e.gl) || a || ("number" == typeof i.wrapMode ? 33071 !== i.wrapMode && console.error("Non-power-of-two textures must have a wrap mode of CLAMP_TO_EDGE!") : 33071 === i.wrapMode.s && 33071 === i.wrapMode.t || console.error("Non-power-of-two textures must have a wrap mode of CLAMP_TO_EDGE!"), i.hasMipmap && console.error("Mipmapping requires power-of-two textures!"));
    }
  }, {
    key: "_applySamplingMode",
    value: function _applySamplingMode(t, e) {
      var i = e.samplingMode,
          a = e.samplingMode;
      9985 === i || 9987 === i ? (i = 9729, e.hasMipmap || (a = 9729)) : 9984 !== i && 9986 !== i || (i = 9728, e.hasMipmap || (a = 9728)), t.texParameteri(e.target, t.TEXTURE_MAG_FILTER, i), t.texParameteri(e.target, t.TEXTURE_MIN_FILTER, a);
    }
  }, {
    key: "_applyWrapMode",
    value: function _applyWrapMode(t, e) {
      "number" == typeof e.wrapMode ? (t.texParameteri(e.target, t.TEXTURE_WRAP_S, e.wrapMode), t.texParameteri(e.target, t.TEXTURE_WRAP_T, e.wrapMode)) : (t.texParameteri(e.target, t.TEXTURE_WRAP_S, e.wrapMode.s), t.texParameteri(e.target, t.TEXTURE_WRAP_T, e.wrapMode.t));
    }
  }, {
    key: "_applyAnisotropicFilteringParameters",
    value: function _applyAnisotropicFilteringParameters(t, e) {
      var i;
      var a = t.capabilities.textureFilterAnisotropic;
      if (!a) return;
      t.gl.texParameterf(e.target, a.TEXTURE_MAX_ANISOTROPY, null != (i = e.maxAnisotropy) ? i : 1);
    }
  }]);

  return o;
}();

function n(t) {
  return e(t) && "type" in t && "compressed" === t.type;
}

o.TEXTURE_UNIT_FOR_UPDATES = 0;
export { o as default };